module.exports = __webpack_public_path__ + "img/shipo-menu-home.563af61e.svg";